// External Imports
import { connect } from 'react-redux';
import React from 'react';
import {
  IconFacebook,
  IconTwitter,
  IconInstagram,
  IconLinkedin,
  IconYoutube,
  Link,
  pxToRem,
  styled,
} from '@lessonnine/design-system.lib';

// Internal Imports
import { getEdition } from '../../selectors/getEdition.js';
import { getSocialLinks, getBabbelRSSUrl } from '../../utils/url.js';
import { LANGUAGES } from '../../config/types/prop.js';
import { options } from '../../config/reactRedux.js';
import { RssIcon } from './RssIcon.jsx';

const SocialLinksNav = styled.nav`
  display: flex;
`;

const SocialLinkList = styled.ul`
  display: flex;
`;

const SocialLinkItem = styled.li`
  margin-left: ${pxToRem(6)};
`;

const socialIconMapping = {
  facebook: <IconFacebook />,
  instagram: <IconInstagram />,
  linkedin: <IconLinkedin />,
  rss: <RssIcon />,
  twitter: <IconTwitter />,
  youtube: <IconYoutube />,
};

function SocialLinks({ currentEdition }) {
  const links = {
    ...getSocialLinks(currentEdition),
    rss: 'rss',
  };

  return (
    // TODO: add translations for the aria label text
    <SocialLinksNav aria-label="Social Links">
      <SocialLinkList>
        {Object.keys(links).map((serviceName) => (
          <SocialLinkItem key={serviceName}>
            <Link
              aria-label={serviceName}
              href={serviceName === 'rss' ? getBabbelRSSUrl(currentEdition) : links[serviceName]}
            >
              {socialIconMapping[serviceName]}
            </Link>
          </SocialLinkItem>
        ))}
      </SocialLinkList>
    </SocialLinksNav>
  );
}

SocialLinks.propTypes = {
  currentEdition: LANGUAGES.isRequired,
};

const mapStateToProps = (state) => ({
  currentEdition: getEdition(state),
});

const withRedux = connect(mapStateToProps, undefined, undefined, options);
const SocialLinksHoc = withRedux(SocialLinks);

// Module Exports
export { SocialLinksHoc as SocialLinks };
